// Module
var code = "<div> <runner-page-description is-show=\"!isMobile\" page-header-text=\"Reports\" help-link=\"{{ctrl.helpUri}}\"> </runner-page-description> <reports back-from-state=\"ctrl.backFromState\"></reports> </div> ";
// Exports
export default code;